/** @format */

export const shippingOptions = {
	SHIP: {
		label: 'Ship',
		subtitle: 'Find items in stock to ship',
		icon: 'vehicle-shipping'
	},
	BOPIS: {
		label: 'Pickup',
		subtitle: 'One-hour curbside or in-store',
		icon: 'building-store'
	},
	ISA: {
		label: 'Shopping In-Store',
		subtitle: 'Find items in stock at your store',
		icon: 'order-cart-standard'
	},
	SDD: {
		label: 'Same Day Delivery',
		subtitle: 'Find items available for same day delivery',
		icon: 'order-delivery'
	}
};

export type ShippingOption = typeof shippingOptions[keyof typeof shippingOptions];

// New copy Update for ship and pickup
export const shippingOptionsNew = {
	SHIP: {
		label: 'Ship',
		subtitle: 'Find items in stock to ship',
		icon: 'vehicle-shipping'
	},
	BOPIS: {
		label: 'Store Pickup',
		subtitle: 'One-hour curbside or in-store',
		icon: 'building-store'
	},
	ISA: {
		label: 'Shopping In-Store',
		subtitle: 'Find items in stock at your store',
		icon: 'order-cart-standard'
	},
	SDD: {
		label: 'Same Day Delivery',
		subtitle: 'Find items available for same day delivery',
		icon: 'order-delivery'
	}
};
